var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIgwsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "529.3px",
    height: "146px",
    viewBox: "0 0 529.3 146",
    enableBackground: "new 0 0 529.3 146",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "IGWS_Logo"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 75.5,
    y: 0,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 145.9826 -75.5061)",
    fill: "#857D78",
    width: 70.5,
    height: 70.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M104.8,36.1c-0.2,0.4-0.4,0.7-0.6,1.1c0.4,0.6,0.6,2.7,2.9,2.6c0,0,0-0.1,0-0.1 C105.4,39.3,104.8,37.3,104.8,36.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M106.7,34c-0.4,0.3-0.7,0.6-1,0.9c0.2,0.8-0.3,3.3,1.8,4c0-0.1,0.1-0.2,0.1-0.2 C105.4,36.8,106.4,34.9,106.7,34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M103.8,38.6c-0.1,0.4-0.1,0.8-0.1,1.2c0.5,0.3,1.6,1.9,3.3,1c0,0,0-0.1,0-0.1 C105.3,40.9,104.2,39.6,103.8,38.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M112.5,33.1c-0.5-0.1-0.9-0.3-1.4-0.3c-0.1,0-0.1,0-0.2,0c-0.6,0.8-3.3,2-1.7,4.6c0.1,0,0.2,0,0.3-0.1 C108.7,35.6,110.8,33.6,112.5,33.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M109.5,32.9c-0.5,0.1-1,0.2-1.5,0.4c-0.3,1-1.9,2.9,0.1,4.8c0.1-0.1,0.2-0.1,0.3-0.2 C106.9,35.1,108.8,33.7,109.5,32.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M104.6,42.9c0.2,0.3,0.5,0.6,0.8,0.9c0.5-0.2,2.2,0.3,2.6-1.4c0,0,0,0-0.1,0 C107.5,43,106.3,43.7,104.6,42.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M108.5,45.1c0,0,0.1,0,0.1,0c0.3-0.3,1.4-0.6,1-2.3c0,0,0,0,0,0C109.7,43.5,109.5,44.4,108.5,45.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M110.3,44.8c0.2-0.1,0.3-0.1,0.5-0.2c0-0.4,0.5-1.1-0.3-2.2c0,0,0,0-0.1,0.1 C110.7,43.2,110.7,44.2,110.3,44.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M111.8,43.7c1-1.1,1.3-2.8,0-4.6c-1.1-1.6-3.2-1.1-3.7,0.5c-0.3,1,0,2.1,1,2.2c1.1,0.1,1.1-1.3,0.5-1.2 c-0.9,0.1-0.7-1.4,0.5-0.9c0.7,0.3,1,1.2,0.8,1.9C111.4,42.1,111.8,43,111.8,43.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M106.4,44.5c0.2,0.1,0.4,0.2,0.6,0.3c0.5-0.2,1.7-0.2,1.8-2c0,0,0,0-0.1,0 C108.6,43.4,107.9,44.5,106.4,44.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M115.3,34.8c-0.5-0.5-1.1-0.9-1.7-1.2c-1.4,0.4-3.9,1.8-3.3,3.8c0.2,0,0.3,0.1,0.5,0.1c0,0,0,0,0.1,0 C111.2,35.7,113.1,34.4,115.3,34.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M103.8,40.9c0,0.2,0.1,0.4,0.1,0.6c0.5,0.1,2.1,1.8,3.4,0.2c0,0-0.1-0.1-0.1-0.1 C106.2,42.2,104.8,41.8,103.8,40.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M106.8,45.5c-0.5-0.2-0.9-0.4-1.3-0.7c0.9,3.5-3.3,7.2-8.2,5.1c0.9,0.9,1.8,1.6,2.8,2.2 C105.9,53.7,108.9,49.6,106.8,45.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M111.2,45.4C111.2,45.4,111.2,45.4,111.2,45.4c-0.3,0.2-0.6,0.3-0.9,0.4c2.3,1.9,2.3,6.3-1.4,8.5 c0.7-0.1,1.4-0.2,2.1-0.4C114.7,50.9,114,46.9,111.2,45.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M109.2,46c-0.5,0.1-0.8,0-1.4-0.1c1.6,4.2-0.9,8-5.6,7.5c1.5,0.6,3.6,0.9,5.1,1 C111.8,52.1,111.6,48.2,109.2,46z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M112.9,43.8c-0.2,0.4-0.5,0.8-0.9,1.1c2.5,1.5,3.9,4.7,1.3,8.1c0.9-0.5,1.8-1.1,2.6-1.9 c0.1-0.1,0.1-0.1,0.2-0.2C116.8,47.7,115.1,44.4,112.9,43.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M113.3,40.3c0.1,0.3,0.1,0.6,0.2,1c1.9-0.4,4.5,1.1,5.3,4c0.2-1.1,0.2-2.2,0.1-3.2 C117.2,39.6,114.9,39.3,113.3,40.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M113.5,42.1c0,0.3-0.1,0.6-0.2,1c2.6,0.4,4,3.6,3.8,6.5c0.6-0.9,1.1-1.8,1.4-2.7 C118,43.7,115.3,41.9,113.5,42.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M118.6,40.5c-0.2-0.6-0.4-1.2-0.6-1.8c-1.4-1-3.7-2.1-5.3,0.2c0.1,0.2,0.2,0.4,0.3,0.6 C114.5,38.4,117,38.7,118.6,40.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M104.5,35.1c1.2-1.9,2.8-2.9,5.6-3c3.2-0.1,6.2,2.4,7.2,3.6c4.5-1.7,7.7-7.1,12.3-10c-1-1-9-9.7-20-8.7 c-6.8,0.6-11.7,4.2-14.7,9.3C94.3,34.3,98.6,38.7,104.5,35.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M117.3,37.4c-0.3-0.6-0.7-1.1-1.1-1.6c-2.2-0.9-4.5,0.3-4.7,2c0.2,0.1,0.4,0.3,0.6,0.4 C113.1,36.8,115.4,36.2,117.3,37.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M103.3,37.6c0.1-0.5,0-0.5,0.2-0.9c-4.3,2.6-10.4-0.6-9.6-8.6c-0.9,1.9-1.3,3.4-1.6,5.5 C93.4,38.6,99.4,43.9,103.3,37.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M104.5,43.8c-0.4-0.4-0.6-0.5-0.9-1c-1.1,3.8-6.5,4.6-10.3,0.9c0.7,1.6,1.3,2.7,2.3,4 C100.6,51.4,105.8,48.3,104.5,43.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M103,41.6c-0.1-0.3-0.2-0.5-0.2-0.8c-0.1-0.5,0-0.6,0-1.1c-3.5,4.7-9.2,0.9-11-3.6 c-0.1,1.5,0,2.7,0.3,4.2c0.1,0.3,0.2,0.7,0.3,1C95.6,46.2,102,46.2,103,41.6z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 70.476 4.967044e-04)",
    fill: "#A80533",
    width: 70.5,
    height: 70.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M31.8,55.9C31.8,55.9,31.7,55.9,31.8,55.9c-0.6,0-1.3-0.4-1.7-1c-0.1-0.1-0.1-0.1-0.2-0.1 c-0.3,0-1,0.6-1.5,1.1c-0.1,0.1-0.2,0.2-0.3,0.3c-0.8,0.8-1.5,0.2-2-0.2c-0.1-0.1-0.2-0.1-0.2-0.2c-0.6-0.4-0.9-0.6-1.4-0.3 c-0.4,0.2-0.8-0.1-1-0.3c0,0.9,0,1.1-0.1,1.2c-0.1,0.1-0.2,0.1-0.3,0.1l0,0c-0.3,0-0.3-0.3-0.3-0.5c0-0.1,0-0.3-0.1-0.3 c0,0-0.1,0-0.3,0c-0.7,0.2-0.9,0.1-1.4-0.4c0,0-0.1,0-0.2,0c-0.1,0-0.1,0.1-0.1,0.2c0.2,0.5,0.2,1,0,1.2c-0.2,0.2-0.7,0.2-1.3-0.1 c-0.2-0.1-0.4-0.3-0.4-0.5c-0.1-0.4,0.2-0.9,0.5-1.4c0.2-0.3,0.3-0.5,0.4-0.7c0.1-0.3,0.2-0.5,0.4-0.7c0.2-0.2,0.3-0.4,0.1-0.8 C20,52,20,51.7,20.2,51.4c0.2-0.3,0.6-0.3,1.3-0.2c0,0,0-0.2,0.1-0.2c0-0.3,0.1-0.6,0.4-0.9c0.6-0.6,0.7-1.1,0.9-1.4 c0-0.1,0.1-0.2,0.1-0.2c0,0,0.1-0.1,0.2-0.3c0.3-0.5,1.1-1.5,1.2-2.2c0.1-0.9-0.6-2.8-1-3.8c-0.1-0.3,0.2-1.2,0.7-1.7 c0.3-0.3,0.3-3.6,0.1-6.7l0.4-19.3l0.2,0.2c0.5,0.3,1.3,0.9,1.6,0.9c0.4,0.1,1.7,0,2.3-0.5c0.7-0.6,1.5-0.9,1.5-0.9l0,0l0,0 l16.3-0.1l0,0.2l0.3,26c0,0.2,0,2.2-0.4,2.7c-0.1,0.1-0.1,0.3,0,0.5c0,0.2,0.1,0.5-0.2,0.8c-0.1,0.1-0.1,0.2-0.1,0.2 c0,0.1,0.2,0.3,0.5,0.5c0.2,0.1,0.3,0.3,0.2,0.5c-0.1,0.4-0.8,0.8-1.4,0.8c-0.2,0-0.5,0.1-0.8,0.2c-0.5,0.2-1.1,0.5-1.9,0.2 c-0.3-0.1-0.6-0.1-0.7,0c-0.2,0.2-0.2,0.6-0.1,1.3c0.1,0.5,0.2,1-0.1,1.4c-0.2,0.2-0.4,0.3-0.8,0.3c-0.4,0-0.5,0.3-0.8,0.8 c-0.2,0.5-0.5,1.1-1.2,1.3c-0.6,0.1-0.6,0.3-0.7,0.7c-0.1,0.4-0.1,0.8-0.5,1.5c-0.4,0.7-0.9,0.8-1.2,0.8c-0.9,0-1.8-0.8-2.1-1.4 c-0.1-0.2-0.2-0.3-0.3-0.3c-0.2,0-0.4,0.2-0.6,0.3c-0.1,0.1-0.2,0.1-0.2,0.2c-0.2,0.1-0.7,0.9-1,1.7C32.2,55.7,32,55.9,31.8,55.9z "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 75.5,
    y: 75.5,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 221.4741 -1.463078e-02)",
    fill: "#5C3354",
    width: 70.5,
    height: 70.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 104.7,
    y: 122.6,
    fill: "#D6D2D1",
    width: 16.9,
    height: 6.4
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#D6D2D1",
    points: "93.8,113.9 85.4,114.7 85.4,120.9 93.8,120.9  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.4,
    y: 122.6,
    fill: "#D6D2D1",
    width: 17.6,
    height: 6.4
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#D6D2D1",
    points: "132.5,120.9 136,120.9 136,110.3 132.5,110.6  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ACA7A4",
    d: "M136,101.5c-10.9,6.7-20.3,3.6-33.8-1.6c-6.7-2.6-12.6-0.9-16.8,1.7V113l50.6-4.4V101.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#857D78",
    d: "M102.8,98.3c13.7,5.3,22.6,8.2,33.2,1.2v-7.1H85.4v7.2C89.9,97.2,95.9,95.6,102.8,98.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#D6D2D1",
    points: "114,120.9 130.9,120.9 130.9,110.7 114,112.2  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.2,
    y: 122.6,
    fill: "#D6D2D1",
    width: 12.8,
    height: 6.4
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#D6D2D1",
    points: "95.4,120.9 112.4,120.9 112.4,112.3 95.4,113.8  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 75.5,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 145.9675 75.492)",
    fill: "#005B93",
    width: 70.5,
    height: 70.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M44.1,121.5c0,4.1-2.8,7.5-6.3,7.5c-3.5,0-6.3-3.3-6.3-7.5c0-4.1,6.3-15.1,6.3-15.1 S44.1,117.4,44.1,121.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M26.7,92.5c0,0-5,8.8-5,12.1c0,3.3,2.2,6,5,6c2.8,0,5-2.7,5-6S26.7,92.5,26.7,92.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M23.9,118.8c0,0-2.8,5-2.8,6.8s1.3,3.4,2.8,3.4s2.8-1.5,2.8-3.4S23.9,118.8,23.9,118.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M45.9,93.6c0,0-3.5,6.2-3.5,8.6c0,2.3,1.6,4.2,3.5,4.2c2,0,3.5-1.9,3.5-4.2S45.9,93.6,45.9,93.6z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M168,20.5h4.7v29.4H168V20.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.5,20.5h5.1l8,15.6c1,1.9,1.5,3,2.5,5.1h0.1V20.5h4.3v29.4H194l-8.8-16.6c-1-1.9-1.5-2.8-2.5-5h-0.1v21.6h-4.3V20.5 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.9,20.5h7.1c8,0,13,3.8,13,14.6c0,10.9-5.1,14.8-13,14.8h-7.1V20.5z M211.5,45.8c5.5,0,7.8-2.9,7.8-10.6 c0-7.5-2.3-10.3-7.8-10.3h-2.9v21H211.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.5,20.5h4.7v29.4h-4.7V20.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.3,49.9h-4.4l8.6-29.6h4.5l8.6,29.6h-4.7l-1.9-7h-8.8L241.3,49.9z M249.9,35.2c-0.9-3.3-1.6-5.8-2.2-8.6h-0.1 c-0.6,2.8-1.4,5.3-2.3,8.5l-1,3.6h6.5L249.9,35.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.1,20.5h5.1l8,15.6c1,1.9,1.5,3,2.5,5.1h0.1V20.5h4.3v29.4h-4.3l-8.8-16.6c-1-1.9-1.5-2.8-2.5-5h-0.1v21.6h-4.3 V20.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.9,49.9h-4.4l8.6-29.6h4.5l8.6,29.6h-4.7l-1.9-7h-8.8L289.9,49.9z M298.5,35.2c-0.9-3.3-1.6-5.8-2.2-8.6h-0.1 c-0.6,2.8-1.4,5.3-2.3,8.5l-1,3.6h6.5L298.5,35.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.7,35.1c0-9.6,4-15.2,11-15.2c5.5,0,8.3,3.3,9.5,9.7l-4.3,0.9c-0.9-4.5-2.5-6.2-5.4-6.2c-3.5,0-6.2,2.9-6.2,10.8 c0,8.1,2.5,11.2,6.4,11.2c3.3,0,5.3-2.2,5.6-7h-4.9v-3.9h9.2v14.6H334V46h-0.1c-0.8,2.1-3.1,4.4-6.8,4.4 C320.5,50.5,316.7,44.8,316.7,35.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.7,20.5h16v4.3h-11.3v7.6h8.2v4.2h-8.2v9.1h11.9v4.2h-16.5V20.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.1,35.2c0-10.2,4.9-15.3,11.2-15.3c6.2,0,11.1,5.1,11.1,15.3s-4.9,15.3-11.1,15.3C366,50.5,361.1,45.4,361.1,35.2z  M378.7,35.2c0-7.2-2.3-10.9-6.4-10.9c-4.1,0-6.5,3.8-6.5,10.9s2.4,11,6.5,11C376.3,46.2,378.7,42.4,378.7,35.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.7,20.5h4.7v25.2h11.3v4.2h-16V20.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.2,35.2c0-10.2,4.9-15.3,11.2-15.3c6.2,0,11.1,5.1,11.1,15.3s-4.9,15.3-11.1,15.3C410.1,50.5,405.2,45.4,405.2,35.2 z M422.8,35.2c0-7.2-2.3-10.9-6.4-10.9c-4.1,0-6.5,3.8-6.5,10.9s2.4,11,6.5,11C420.5,46.2,422.8,42.4,422.8,35.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.7,35.1c0-9.6,4-15.2,11-15.2c5.5,0,8.3,3.3,9.5,9.7l-4.3,0.9c-0.9-4.5-2.5-6.2-5.4-6.2c-3.5,0-6.2,2.9-6.2,10.8 c0,8.1,2.5,11.2,6.4,11.2c3.3,0,5.3-2.2,5.6-7h-4.9v-3.9h9.2v14.6H448V46h-0.1c-0.8,2.1-3.1,4.4-6.8,4.4 C434.4,50.5,430.7,44.8,430.7,35.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.9,20.5h4.7v29.4h-4.7V20.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.1,35.2c0-10.2,4.5-15.2,11-15.2c6,0,8.6,3.9,9.5,9.7l-4.4,0.8c-0.8-4.2-2.2-6.1-5.3-6.1c-4.1,0-6.2,3.8-6.2,10.8 c0,7.3,2.1,11.1,6.2,11.1c3.1,0,4.7-1.8,5.6-6.5l4.3,0.7c-1.1,5.8-3.9,10-9.9,10C470.4,50.5,466.1,45.5,466.1,35.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.4,49.9H488l8.6-29.6h4.5l8.6,29.6H505l-1.9-7h-8.8L492.4,49.9z M501.1,35.2c-0.9-3.3-1.6-5.8-2.2-8.6h-0.1 c-0.6,2.8-1.4,5.3-2.3,8.5l-1,3.6h6.5L501.1,35.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.2,20.5h4.7v25.2h11.3v4.2h-16V20.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,83.8c0-4.5,2.7-7,5.8-9c-1.1-2.2-1.8-4.5-1.8-7c0-4.1,2.5-7.1,6.9-7.1c4.4,0,6.2,2.8,6.2,5.8 c0,4.2-2.9,6.6-6.2,8.8c0.6,1,1.2,1.9,1.8,2.9c1.2,1.6,2.3,3.2,3.5,4.5c1-1.9,1.6-4.4,1.8-7h4c-0.4,3.4-1.3,6.8-2.8,9.5 c1.6,1.2,3.1,1.9,4.6,1.9v4c-2.8-0.1-5.1-0.9-7.3-2.5c-1.9,1.7-4.3,2.7-7.4,2.7C169.4,91.3,166,88.5,166,83.8z M179.6,86.2 c-1.4-1.5-2.7-3.3-4.2-5.4c-0.7-1-1.4-1.9-2-2.9c-1.8,1.5-3,3.3-3,5.5c0,2.4,1.5,4.3,4.9,4.3C177,87.7,178.5,87.2,179.6,86.2z  M179.2,66.9c0-1.5-0.6-2.6-2.2-2.6c-1.7,0-2.7,1.2-2.7,3.2c0,1.6,0.4,3.2,1.2,4.9C177.5,71,179.2,69.4,179.2,66.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.5,61.3h4.5l2.7,13.5c0.6,2.9,1,4.6,1.6,8.3h0.1c0.6-3.6,0.9-5.3,1.5-8.3l2.6-13.5h4.2l2.7,13.8 c0.6,2.8,1,4.8,1.4,8h0.1c0.5-3.1,0.9-5.1,1.5-7.9l2.8-13.8h4.1l-6.6,29.6h-4l-4.2-21.6h-0.1l-4.3,21.6h-4.1L198.5,61.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.6,90.7h-4.4l8.6-29.6h4.5l8.6,29.6h-4.7l-1.9-7h-8.8L232.6,90.7z M241.2,76c-0.9-3.3-1.6-5.8-2.2-8.6h-0.1 c-0.6,2.8-1.4,5.3-2.3,8.5l-1,3.6h6.5L241.2,76z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.9,65.6h-7.3v-4.3h19.3v4.3h-7.3v25.1h-4.7V65.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.5,61.3h16v4.3h-11.3v7.6h8.2v4.2h-8.2v9.1H288v4.2h-16.5V61.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292,61.3h8.8c5.9,0,9.5,2.7,9.5,8.9c0,4.4-2.1,7-5.1,8l5.6,12.5H306l-5.3-11.5h-4.1v11.5H292V61.3z M300.6,75.3 c3.4,0,5.2-1.2,5.2-5c0-3.5-1.7-4.7-5.2-4.7h-4v9.7H300.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322,84.2l3.9-1.9c1.3,2.8,3.4,4.9,6.5,4.9c3,0,4.7-1.4,4.7-3.8c0-2.9-2.7-4.2-5.6-5.6c-3.8-1.8-8.3-3.6-8.3-9.3 c0-4.6,3.7-7.8,8.7-7.8c4.9,0,7.7,2.7,9.4,6.4l-3.9,2c-1.2-2.5-2.7-4.3-5.5-4.3c-2.4,0-4,1.3-4,3.4c0,2.9,2.5,4.2,5.4,5.5 c3.9,1.8,8.5,3.7,8.5,9.3c0,4.4-3.4,8.1-9.3,8.1C327.1,91.2,324,88.3,322,84.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.3,80.8V61.3h4.7v19.1c0,4.5,1.4,6.7,5.1,6.7c3.7,0,5-2.2,5-6.6V61.3h4.5v19.5c0,6.4-2.8,10.5-9.6,10.5 C348.2,91.2,345.3,87.3,345.3,80.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.8,61.3h8.8c5.9,0,9.5,2.7,9.5,8.9c0,4.4-2.1,7-5.1,8l5.6,12.5h-4.8l-5.3-11.5h-4.1v11.5h-4.6V61.3z M378.3,75.3 c3.4,0,5.2-1.2,5.2-5c0-3.5-1.7-4.7-5.2-4.7h-4v9.7H378.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.1,61.3h4.7l3.9,14.9c0.8,3.1,1.4,5.5,2.1,8.4h0.1c0.6-2.9,1.3-5.3,2.1-8.3l4-15h4.4L403,90.8h-4.5L390.1,61.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.9,61.3h16v4.3h-11.3v7.6h8.2v4.2h-8.2v9.1h11.9v4.2h-16.5V61.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.1,78.9l-8.2-17.6h4.8l5.8,13.3h0.1l5.8-13.3h4.6l-8.2,17.5v11.9h-4.7V78.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M167.7,106.7h2v17.7h-2V106.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.4,106.7h2.3l5.5,10.8c0.6,1.2,1,1.9,1.6,3.1h0v-13.9h1.8v17.7h-1.8L183,113c-0.7-1.3-1-1.9-1.7-3.3h0v14.7h-1.8 V106.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.4,106.7h3.9c4.9,0,7.5,2.6,7.5,8.8s-2.7,8.9-7.5,8.9h-3.9V106.7z M204.5,122.6c3.6,0,5.2-2.1,5.2-7.1 c0-4.8-1.7-7-5.3-7h-2.1v14H204.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.8,106.7h2v17.7h-2V106.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.2,124.4h-1.9l5.2-17.7h1.9l5.2,17.7h-2l-1.4-5.1h-5.5L233.2,124.4z M238.9,114.8c-0.6-2.1-1.1-3.7-1.5-5.4h0 c-0.4,1.7-0.9,3.3-1.5,5.4l-0.8,2.7h4.5L238.9,114.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252,106.7h2.3l5.5,10.8c0.6,1.2,1,1.9,1.6,3.1h0v-13.9h1.8v17.7h-1.8l-5.9-11.4c-0.7-1.3-1-1.9-1.7-3.3h0v14.7H252 V106.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.6,124.4h-1.9l5.2-17.7h1.9l5.2,17.7h-2l-1.4-5.1H275L273.6,124.4z M279.3,114.8c-0.6-2.1-1.1-3.7-1.5-5.4h0 c-0.4,1.7-0.9,3.3-1.5,5.4l-0.8,2.7h4.5L279.3,114.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.2,118.6v-11.9h2v11.6c0,2.9,0.9,4.6,3.5,4.6c2.6,0,3.5-1.7,3.5-4.6v-11.7h1.9v11.8c0,3.6-1.6,6.2-5.5,6.2 C303.8,124.7,302.2,122.2,302.2,118.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.7,106.7h2.3l5.5,10.8c0.6,1.2,1,1.9,1.6,3.1h0v-13.9h1.8v17.7h-1.8l-5.9-11.4c-0.7-1.3-1-1.9-1.7-3.3h0v14.7h-1.8 V106.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.8,106.7h2v17.7h-2V106.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.3,106.7h2l2.6,9.6c0.6,2,1,3.7,1.4,5.4h0c0.4-1.7,0.9-3.3,1.4-5.3l2.6-9.6h1.9l-5.1,17.7h-1.9L354.3,106.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.8,106.7h9v1.8h-7v5.6h5.1v1.8h-5.1v6.6h7.4v1.8h-9.4V106.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.9,106.7h5c3.4,0,5.4,1.6,5.4,5c0,2.8-1.5,4.3-3.3,4.8l3.6,7.9h-2.1l-3.5-7.5h-3.1v7.5h-2V106.7z M397.8,115.1 c2.3,0,3.6-0.9,3.6-3.4c0-2.3-1.2-3.2-3.6-3.2h-2.9v6.6H397.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.3,120.5l1.7-0.8c0.8,1.9,2.1,3.2,4.2,3.2c2.1,0,3.3-1.1,3.3-2.8c0-2.1-1.7-2.9-3.6-3.8c-2.2-1.1-4.8-2.2-4.8-5.4 c0-2.6,2.1-4.4,4.8-4.4c2.8,0,4.4,1.7,5.3,3.7l-1.7,0.8c-0.6-1.5-1.7-2.8-3.6-2.8c-1.7,0-2.8,1.1-2.8,2.6c0,2.1,1.7,2.9,3.6,3.8 c2.3,1.1,4.8,2.2,4.8,5.5c0,2.6-2,4.7-5.3,4.7C414.2,124.7,412.4,123,411.3,120.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.5,106.7h2v17.7h-2V106.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.6,108.5H442v-1.8h11.1v1.8h-4.6v15.8h-2V108.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.1,117.1l-4.9-10.4h2.1l3.9,8.5h0l3.9-8.5h1.9l-4.9,10.3v7.3h-2V117.1z"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIgwsLogo);
export default __webpack_public_path__ + "static/media/IGWSLogo.b3a34d90e3c6f51b0bc5a5dba3ed3ee9.svg";
export { ForwardRef as ReactComponent };